import React from "react";
import { IConfigurationProps } from "../add-tenancy-condition/AddTenancyCondition";
import { CreateProposalHeaderGallery } from "./create-proposa-header-gallery";

interface CreateProposalGalleryPopupProps {
    proposalCoverImages: any[];
    selectedImages: any[];
    setGalleryPopup: React.Dispatch<React.SetStateAction<boolean>>;
    setSelectedImages: React.Dispatch<React.SetStateAction<any[]>>;
    title?: string
}

export function CreateProposalGalleryPopup({ proposalCoverImages,
    title,
    selectedImages,
    setGalleryPopup,
    setSelectedImages }: CreateProposalGalleryPopupProps) {
    return (
        <>
            <div
                className={`detail-poupup  position-fixed top-0 w-100 h-100 overflow-auto in `}
                style={{ zIndex: 1051 }}
                id="galleryPopup"
            >
                <CreateProposalHeaderGallery
                    title={title}
                    setGalleryPopup={setGalleryPopup}
                />

                <div className="py-4 px-5">
                    <div className="row img-uploader-gallery gutter-5 py-1">
                        {proposalCoverImages.map((image, index) => {
                            return (
                                <div
                                    className="col-sm-3"
                                    key={index}
                                    style={{ marginBottom: "10px" }}
                                >
                                    <div className="item-img-upload overflow-hidden position-relative w-100">
                                        <img
                                            src={image?.media?.location}
                                            alt="img"
                                            className="img-fluid h-100 w-100"
                                        />
                                        <span className="strap d-block position-absolute text-uppercase text-white font-weight-semibold">
                                            {image?.media?.originalname}
                                        </span>
                                        <span className="checkbox d-flex justify-content-center align-items-center position-absolute rounded-circle">
                                            <input
                                                type="checkbox"
                                                name="checkprop-create-proposal"
                                                id={`item_${index}`}
                                                checked={selectedImages.some((item) => image._id === item._id)}
                                                onClick={() => {
                                                    if (selectedImages.some((item) => image._id === item._id)) {
                                                        setSelectedImages(prev => prev.filter(img => img?._id !== image._id))
                                                    } else {
                                                        setSelectedImages(prev => [...prev, image])
                                                    }
                                                }}
                                            />
                                            <label htmlFor={`item_${index}`}></label>
                                        </span>
                                    </div>
                                </div>
                            );
                        })}
                        <div className="col-sm-12 mt-5 text-right">
                            <button
                                className="btn btn-primary font-normal font-weight-semibold px-4 py-2"
                                style={{ height: "40px", borderRadius: "4px" }}
                                onClick={() => setGalleryPopup(false)}
                            >
                                Add Photo
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal-backdrop fade show" style={{ zIndex: 1050 }}></div>
        </>
    );
}
